import * as t from 'io-ts';

export const LoyaltyTransactionDynamicType = t.interface({
    date: t.string,
    activity: t.string,
    pointsChange: t.number,
    total: t.number
});

export type LoyaltyTransaction = t.TypeOf<typeof LoyaltyTransactionDynamicType>;
